import { Spinner as CBSpinner } from '@cb/apricot-react';
function Spinner(_ref) {
  var spinnerId = _ref.spinnerId,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Loading...' : _ref$ariaLabel,
    _ref$light = _ref.light,
    light = _ref$light === void 0 ? false : _ref$light,
    _ref$palette = _ref.palette,
    palette = _ref$palette === void 0 ? '' : _ref$palette,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '32' : _ref$size,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline;
  if (inline) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'inline-block'
      }
    }, /*#__PURE__*/React.createElement(CBSpinner, {
      spinnerId: spinnerId,
      className: className,
      ariaLabel: ariaLabel,
      light: light,
      palette: palette,
      size: size,
      text: text
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-height-50-vh display-flex",
    style: {
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(CBSpinner, {
    spinnerId: spinnerId,
    className: className,
    ariaLabel: ariaLabel,
    light: light,
    palette: palette,
    size: size,
    text: text
  }));
}
export default Spinner;